import React, { Fragment, useState } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import "./steps.css";
import 'bootstrap/dist/js/bootstrap.bundle.min';

const OnboardingFAQ = (props) => {
  const [activeAccordion, setActiveAccordion] = useState(1);
  const [activeTab, setActiveTab] = useState('android');

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 md:pt-30 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Onboarding FAQs</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section sofax-section-padding2 pt-65 pb-130">
          <div className="container mt-5">
            <div className="faq-container">
              <ul className="accordion-box">
                <li className={`accordion block ${activeAccordion === 1 ? 'active-block' : ''}`}>
                  <div className="acc-btn" onClick={() => toggleAccordion(1)}>
                    <div className="icon-box" />
                    <h4>
                      1. I'm getting this screen. What should I do?
                    </h4>
                  </div>
                  <div className="acc-content" style={{ display: activeAccordion === 1 ? 'block' : 'none' }}>
                    <div className="text">
                      <p>Does your screen look something like this?</p>
                      <div className="row mb-4">
                        <div className="col-8 col-md-5 col-lg-3">
                          <div className="cardcss">
                            <img
                              className="card-img-top"
                              src="/images/onboarding-faq/main-1.png"
                              alt="Camera access denied screen"
                            />
                          </div>
                        </div>
                      </div>
                      <p className="mb-4">
                        This means the CAMERA access is denied. please follow the steps below to Allow camera access.
                      </p>

                      <ul className="nav nav-pills style1 justify-content-center mb-4" id="pills-tab" role="tablist">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${activeTab === 'android' ? 'active' : ''}`}
                            onClick={() => setActiveTab('android')}
                            href="#android"
                            role="button"
                          >
                            <h6 className="mb-0">Android Steps</h6>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={`nav-link ${activeTab === 'ios' ? 'active' : ''}`}
                            onClick={() => setActiveTab('ios')}
                            href="#ios"
                            role="button"
                          >
                            <h6 className="mb-0">iOS Steps</h6>
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        {/* Android Content */}
                        <div className={`tab-pane fade ${activeTab === 'android' ? 'show active' : ''} animate-fade`}>
                          <div className="instruction-step">
                            <div className="step-number">1</div>
                            <div className="step-content">
                              <div className="step-text">Go to mobile settings and scroll down to find Apps option, tap on it.</div>
                              <div className="row mt-3">
                                <div className="col-12 col-md-8">
                                  <div className="cardcss">
                                    <img className="card-img-top" src="/images/onboarding-faq/New1.png" alt="Step 1" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="instruction-step">
                            <div className="step-number">2</div>
                            <div className="step-content">
                              <div className="step-text">Select Manage apps from the options.</div>
                                 <div className="row mt-3">
                                <div className="col-12 col-md-8">
                                  <div className="cardcss">
                                    <img className="card-img-top" src="/images/onboarding-faq/New2.png" alt="Step 3" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="instruction-step">
                            <div className="step-number">3</div>
                            <div className="step-content">
                              <div className="step-text">Scroll down, find the TigrisPay app in the list, and tap on it.</div>
                              <div className="row mt-3">
                                <div className="col-12 col-md-8">
                                  <div className="cardcss">
                                    <img className="card-img-top" src="/images/onboarding-faq/New3.png" alt="Step 3" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="instruction-step">
                            <div className="step-number">4</div>
                            <div className="step-content">
                              <div className="step-text">Open App Permissions, tap on Camera, and allow the permission.</div>
                              <div className="row mt-3">
                                <div className="col-12 col-md-8">
                                  <div className="cardcss">
                                    <img className="card-img-top" src="/images/onboarding-faq/New4.png" alt="Step 4" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* iOS Content */}
                        <div className={`tab-pane fade ${activeTab === 'ios' ? 'show active' : ''} animate-fade`}>
                          <div className="instruction-step">
                            <div className="step-number">1</div>
                            <div className="step-content">
                              <div className="step-text">Go to mobile settings and scroll down to find Apps option, tap on it.</div>
                              <div className="row mt-3">
                                <div className="col-12 col-md-8">
                                  <div className="cardcss">
                                    <img className="card-img-top" src="/images/onboarding-faq/ios1.png" alt="Step 1" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="instruction-step">
                            <div className="step-number">2</div>
                            <div className="step-content">
                              <div className="step-text">Scroll down, find the TigrisPay app in the list, and tap on it.</div>
                              <div className="row mt-3">
                                <div className="col-12 col-md-8">
                                  <div className="cardcss">
                                    <img className="card-img-top" src="/images/onboarding-faq/ios2.png" alt="Step 2" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="instruction-step">
                            <div className="step-number">3</div>
                            <div className="step-content">
                              <div className="step-text">Tap on Camera, and allow the permission.</div>
                              <div className="row mt-3">
                                <div className="col-12 col-md-8">
                                  <div className="cardcss">
                                    <img className="card-img-top" src="/images/onboarding-faq/ios3.png" alt="Step 3" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li className={`accordion block ${activeAccordion === 2 ? 'active-block' : ''}`}>
                  {/* <div className="acc-btn" onClick={() => toggleAccordion(2)}>
                    <div className="icon-box" />
                    <h4>
                      2. I'm getting error message saying, "Wrong ID document
                      or something went wrong..."
                    </h4>
                  </div> */}
                  {/* <div className="acc-content" style={{ display: activeAccordion === 2 ? 'block' : 'none' }}>
                    <div className="text">
                      <p>Does your screen look something like this?</p>
                      <div className="row">
                        <div className="col-8 col-md-5 col-lg-3">
                          <div className="cardcss">
                            <img
                              className="card-img-top"
                              src="/images/onboarding-faq/ID Upload failure.png"
                              alt="Wrong ID document or something went wrong."
                            />
                          </div>
                        </div>
                      </div>
                      <p className="mt-2">
                        This means the ID you uploaded is not supported or was
                        having glare or blur while uploading. This may have
                        resulted us in not been able to capture ID details.
                        Please give it another try or contact our support
                        team.
                      </p>
                    </div>
                  </div> */}
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default OnboardingFAQ;
